import HotplaceDetailActions from '@/components/feature/list-type/hotplace/hotplace-detail-actions';
import clsx from 'clsx';
import styles from './styles.module.scss';

interface HotplaceContentProps {
    title: string;
    body: string;
    showPoiActions: boolean;
    showActionsInline: boolean;
    onLocationClick: () => void;
    onDirectionClick: () => void;
}

const MAX_TITLE_LENGTH = 36;

const HotplaceContent = ({
    title,
    body,
    showPoiActions,
    showActionsInline,
    onLocationClick,
    onDirectionClick,
}: HotplaceContentProps) => {
    const truncatedTitle =
        title.length > MAX_TITLE_LENGTH ? `${title.slice(0, MAX_TITLE_LENGTH)}...` : title;
    return (
        <div className={styles['panel__content']}>
            <h2
                className={clsx(styles['panel__title'], 'focus-border')}
                tabIndex={3}
                data-interactive
                aria-label={title}
                data-region-nav
                data-region-order={3}
            >
                {truncatedTitle}
            </h2>
            <div
                className={clsx(styles['panel__body'], 'scrollbar-custom-gray-99938f scrollbar-w-6', {
                    [styles['panel__body--fullsize']]: !showPoiActions,
                })}
            >
                <div
                    className={clsx(styles['panel__text'], 'focus-border')}
                    tabIndex={4}
                    data-interactive
                    aria-label={body}
                    data-region-nav
                    data-region-order={4}
                >
                    {body}
                </div>
            </div>
            {showPoiActions && showActionsInline && (
                <div className={styles['panel__actions']}>
                    <HotplaceDetailActions onLocationClick={onLocationClick} onDirectionClick={onDirectionClick} />
                </div>
            )}
        </div>
    );
};

export default HotplaceContent;
